module.exports = function isEmptyObject(data) {
    if(!typeof(data)){
        return false;
    }
    if(Object.entries(data).length !== 0 && data.constructor === Object){
        return false;
    }
    return true;
}